import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import centsToDecimal from 'modules/core/lib/formatCents'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  maxYearlyHoursInCents?: number
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
}

const MaxYearlyHours = ({ maxYearlyHoursInCents, workingConditionVersionApplication }: Props) => {
  const maxLegalHours = maxYearlyHoursInCents ? centsToDecimal(maxYearlyHoursInCents) : undefined

  return (
    <Item
      id="max_legal_yearly_hours"
      title={i18n.t('contract_versions.time.max_legal_yearly_hours.title')}
      description={maxLegalHours?.toString()}
      workingConditionVersionApplication={workingConditionVersionApplication}
    />
  )
}

export default observer(MaxYearlyHours)
